import { render, staticRenderFns } from "./StoresView.vue?vue&type=template&id=d2c16894&scoped=true&"
import script from "./StoresView.vue?vue&type=script&lang=ts&"
export * from "./StoresView.vue?vue&type=script&lang=ts&"
import style0 from "./StoresView.vue?vue&type=style&index=0&id=d2c16894&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c16894",
  null
  
)

export default component.exports